import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './Reducers';

// Creating the Redux store using configureStore
const store = configureStore({
  reducer: rootReducer
});

export default store;
export type RootState = ReturnType<typeof store.getState>;

// Infer the AppDispatch type from the store itself
export type AppDispatch = typeof store.dispatch;